var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOpinionServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 198,
    viewBox: "0 0 205 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0996,
    y: 23.6406,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 67.9023,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 77.165,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 86.4277,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2217,
    y: 95.6904,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6781 46.8193V47.641C46.6781 48.7304 46.6781 49.9535 46.3245 51.7977L45.1014 51.6735C45.4311 50.0299 45.4454 48.8068 45.455 47.7844H40.3332V46.8193H46.6781ZM47.4426 52.7055V53.6993H39.5114V52.7055H42.3494V49.7146H43.563V52.7055H47.4426ZM55.9279 52.7437V53.7184H47.9681V52.7437H51.2935V50.7753H52.507V52.7437H55.9279ZM52.5453 47.1824C52.5453 48.4246 53.6633 49.7337 55.6508 50.0395L55.1348 51.0524C53.6059 50.7753 52.4688 49.9583 51.8955 48.8737C51.3221 49.9535 50.1946 50.7801 48.6752 51.0524L48.1592 50.0395C50.1277 49.7337 51.2361 48.415 51.2457 47.1824V46.5613H52.5453V47.1824ZM61.3651 46.6473V47.6219H59.6355C59.6451 48.6348 60.2519 49.6143 61.6422 50.0204L61.0593 50.976C60.099 50.6845 59.4349 50.1016 59.0526 49.3515C58.6656 50.2306 57.9585 50.9282 56.9122 51.2722L56.2911 50.3071C57.734 49.8532 58.3837 48.7256 58.4029 47.6219H56.6255V46.6473H61.3651ZM63.324 46.0644V48.0806H64.4993V49.0744H63.324V51.2244H62.1009V46.0644H63.324ZM60.4764 51.3964C62.2824 51.3868 63.41 52.008 63.41 53.0686C63.41 54.1293 62.2824 54.76 60.4764 54.76C58.6322 54.76 57.4951 54.1293 57.4951 53.0686C57.4951 52.008 58.6322 51.3868 60.4764 51.3964ZM60.4764 52.3424C59.3298 52.3424 58.7086 52.5813 58.7182 53.0686C58.7086 53.5655 59.3298 53.814 60.4764 53.814C61.604 53.814 62.206 53.5655 62.206 53.0686C62.206 52.5813 61.604 52.3424 60.4764 52.3424Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.0791,
    y: 7.2002,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 51.4619,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 60.7246,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 69.9873,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.2012,
    y: 79.25,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3098 30.2068C64.6858 30.1973 65.7178 31.0955 65.7178 32.3377C65.7178 33.5895 64.6858 34.4782 63.3098 34.4782C61.9338 34.4782 60.8922 33.5895 60.8922 32.3377C60.8922 31.0955 61.9338 30.1973 63.3098 30.2068ZM63.3098 31.2579C62.6218 31.2579 62.0962 31.6593 62.1058 32.3377C62.0962 33.0257 62.6218 33.4175 63.3098 33.4175C63.9978 33.4175 64.5234 33.0257 64.5329 32.3377C64.5234 31.6593 64.0074 31.2579 63.3098 31.2579ZM67.8009 29.6239V38.3387H66.5874V29.6239H67.8009ZM60.5291 35.5675C62.0771 35.5771 64.2271 35.5484 66.0905 35.2904L66.186 36.1695C64.2558 36.5422 62.1918 36.5613 60.6724 36.5613L60.5291 35.5675ZM76.2672 29.6335V36.0453H75.0632V34.2297H73.0756V33.2551H75.0632V32.2804H73.1999C72.5787 33.6038 71.3174 34.5833 69.5687 35.1089L69.0623 34.1629C70.9161 33.5752 72.0819 32.5432 72.3016 31.2579H69.5305V30.2833H73.6299C73.6299 30.6368 73.5916 30.9808 73.5248 31.3057H75.0632V29.6335H76.2672ZM76.4965 37.192V38.1667H70.5434V35.4051H71.7856V37.192H76.4965ZM80.6915 31.5924C80.6915 33.2264 81.3508 34.8126 82.8033 35.4433L82.0579 36.418C81.0928 35.945 80.4478 35.0802 80.0895 34.01C79.7072 35.1471 79.0383 36.0788 78.0446 36.5709L77.2801 35.5771C78.7708 34.9082 79.4492 33.2264 79.4588 31.5924V30.2928H80.6915V31.5924ZM84.7431 29.6239V38.3387H83.539V33.3411H81.8286V32.3568H83.539V29.6239H84.7431Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_1528)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.423,
    y: 50.793,
    width: 75.3348,
    height: 99.8914,
    rx: 3.01076,
    transform: "rotate(18.5895 120.423 50.793)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.751,
    y: 96.9297,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 118.751 96.9297)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.798,
    y: 105.709,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 115.798 105.709)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.846,
    y: 114.489,
    width: 49.1133,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 112.846 114.489)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.893,
    y: 123.269,
    width: 35.2931,
    height: 2.48861,
    rx: 1.24431,
    transform: "rotate(18.5895 109.893 123.269)",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.846 81.5998C141.153 82.0294 141.845 83.2098 141.449 84.3872C141.05 85.5737 139.788 86.087 138.484 85.6483C137.18 85.2097 136.476 84.0353 136.875 82.8489C137.271 81.6714 138.544 81.1521 139.846 81.5998ZM139.511 82.5961C138.858 82.3768 138.232 82.5896 138.025 83.2357C137.797 83.8848 138.17 84.4237 138.822 84.643C139.474 84.8623 140.097 84.6585 140.326 84.0095C140.533 83.3634 140.172 82.8185 139.511 82.5961ZM144.288 82.479L141.51 90.7391L140.36 90.3522L143.138 82.0922L144.288 82.479ZM135.501 85.7944C136.965 86.2969 139.012 86.9552 140.861 87.3046L140.671 88.1683C138.723 87.9062 136.76 87.2664 135.32 86.782L135.501 85.7944ZM152.31 85.187L150.266 91.2643L149.125 90.8805L149.703 89.1597L147.82 88.5261L148.13 87.6022L150.014 88.2358L150.325 87.312L148.559 86.718C147.548 87.7744 146.04 88.3007 144.215 88.2414L144.037 87.1833C145.981 87.2172 147.415 86.6107 148.033 85.4626L145.407 84.5792L145.717 83.6553L149.603 84.9622C149.49 85.2973 149.344 85.6111 149.177 85.8978L150.636 86.3882L151.169 84.8032L152.31 85.187ZM150.118 92.4243L149.807 93.3481L144.164 91.4503L145.045 88.8328L146.222 89.2288L145.653 90.9225L150.118 92.4243ZM155.879 88.4541C155.358 90.0029 155.477 91.7165 156.653 92.7773L155.636 93.4636C154.872 92.7076 154.536 91.6823 154.538 90.5537C153.813 91.5096 152.882 92.1794 151.783 92.3291L151.375 91.1434C153.001 90.9846 154.18 89.6069 154.71 88.0612L155.125 86.8294L156.293 87.2224L155.879 88.4541ZM160.347 87.88L157.568 96.14L156.427 95.7562L158.02 91.0193L156.399 90.4741L156.713 89.5412L158.334 90.0865L159.205 87.4961L160.347 87.88Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.3555,
    y: 157.779,
    width: 6.41458,
    height: 40.5167,
    transform: "rotate(-35 56.3555 157.779)",
    fill: "#1F2E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2511 150.612L61.6112 154.09L56.3438 157.778L55.2511 150.612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5342 135.449L105.884 134.543L111.606 174.654L105.256 175.56L99.5342 135.449Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.789 128.558L105.889 134.535L99.5232 135.444L101.789 128.558Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_1528",
    x: 14.0996,
    y: 23.6406,
    width: 81.3565,
    height: 105.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1528",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_1528",
    x: 35.0791,
    y: 7.2002,
    width: 81.3565,
    height: 105.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1528",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_1528",
    x: 89.3809,
    y: 51.5947,
    width: 107.666,
    height: 123.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01076,
    dy: 3.01076
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50538
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_1528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_1528",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpinionServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcOpinionServiceBodyMobile.bbc672ab85cee99dedc74677a53ae8c5.svg";
export { ForwardRef as ReactComponent };